import React, { useEffect } from "react";
import { useFormik } from "formik";
import SignInImg from "../../../assets/signin_img.png";
import logoImg from "../../../assets/logo_svg.svg";
import googleIcon from "../../../assets/google_icon.png";
import { SignInSchema, initialValues } from "./validation/SignInSchema";
import { CustomButton } from "../../../components/button/CustomButton";
import { useDispatch } from "react-redux";
import { userLoginThunk as onUserLogin } from "../../../slices/auth/login/thunk";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { Spinner } from "../../../components/spinner/Spinner";
import { resetFlags as ResetLoginFlags } from "../../../slices/auth/login/reducer";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { googleLoginThunk } from "../../../slices/auth/google/thunk";

export const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // const login = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {
  //     try {
  //       const res = await axios.get(
  //         "https://www.googleapis.com/oauth2/v3/userinfo",
  //         {
  //           headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
  //         }
  //       );
  //       const email = res.data.email;

  //       if (!email) return toast.error("No email returned from Google");

  //       // Dispatch Redux thunk for Google login
  //       dispatch(googleLoginThunk(email)).then((res) => {
  //         if (res.meta.requestStatus === "fulfilled") navigate("/user");
  //       });
  //     } catch (error) {
  //       toast.error("Google login failed");
  //     }
  //   },
  //   onError: () => toast.error("Google login failed"),
  // });

const login = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    try {
      const googleRes = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        }
      );

      const email = googleRes.data.email;
      if (!email) {
        toast.error("No email returned from Google");
        return;
      }

      const res = await dispatch(googleLoginThunk(email));

      if (res.meta.requestStatus !== "fulfilled") {
        toast.error("Login failed");
        return;
      }

      //  SAFE PAYLOAD HANDLING
      const payload = res.payload;
      const data = payload?.data || payload; //   MAIN FIX

      const user = data?.user;
      const token = data?.accessToken;

      if (!user || !token) {
        console.error("Invalid login payload:", payload);
        toast.error("Invalid login response");
        return;
      }

      const userType = Number(user.user_type);

      // Save
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      // Redirect
      if (userType === 1) {
        navigate("/user");
      } else if (userType === 2) {
        navigate("/artist");
      } else {
        navigate("/");
      }

      toast.success("Login successful");

    } catch (error) {
      console.error("Google Login Error:", error);
      toast.error("Google login failed");
    }
  },
  onError: () => toast.error("Google login failed"),
});

  const dispatch = useDispatch();
  const Formik = useFormik({
    initialValues: initialValues,
    validationSchema: SignInSchema,
    onSubmit: (values, action) => {
      const userData = {
        email: values["email"],
        password: values["password"],
      };
      dispatch(onUserLogin(userData));
    },
  });

  const { values, errors, touched, handleChange, handleSubmit, handleBlur } =
    Formik;
  const selectUserState = (state) => state.auth;
  const userProperties = createSelector(selectUserState, (ecom) => ({
    isLoginSuccess: ecom.isLoginSuccess,
    isLoading: ecom.isLoading,
  }));

  // Inside your component
  const { isLoginSuccess, isLoading } = useSelector(userProperties);

  useEffect(() => {
    if (isLoginSuccess) {
      dispatch(ResetLoginFlags());
      toast.success("Login successfully!");
      navigate("/user");
    }
  }, [isLoginSuccess, navigate, dispatch]);

  return (
    <>
      <div className="flex min-h-screen w-full">
        <div className="w-full md:w-1/2 bg-white  flex items-center justify-center ">
          <div className=" w-full max-w-[542px] p-4  bg-white">
            {/* Logo */}
            <div className="flex items-center justify-center py-8">
              <div className="w-[121px] h-[123px] ">
                <img
                  src={logoImg}
                  alt="Loading"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Login Heading */}
            <h2 className="text-[32px] font-grotesk md:text-2xl font-bold mb-3 text-left text-[#3749A6]">
              Login
            </h2>
            {/* Form */}
            <form onSubmit={handleSubmit}>
              {/* Email Field */}
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-lable_color font-grotesk text-[16px] font-bold mb-1"
                >
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none  focus:ring-1 focus:ring-primary focus:border-primary "
                  placeholder="Enter Your Email"
                />
                {errors.email && touched.email ? (
                  <p className="text-red-600 text-[12px]">{errors.email}</p>
                ) : null}
              </div>
              {/* Password Field*/}
              <div className="mb-4 relative">
                <label
                  htmlFor="password"
                  className="block text-lable_color font-grotesk text-[16px] font-bold mb-1"
                >
                  Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none  focus:ring-1 focus:ring-primary focus:border-primary"
                  placeholder="Enter Your Password"
                />
                <div
                  className="absolute right-3 top-12 cursor-pointer text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
                {errors.password && touched.password ? (
                  <p className="text-red-600 text-[12px]">{errors.password}</p>
                ) : null}
              </div>
              {/*Forgot password */}
              <div className="mb-6 flex items-center justify-end text-sm">
                <Link
                  href=""
                  className="text-lable_color font-grotesk text-xs sm:text-sm font-bold hover:underline hover:text-primary tracking-wide"
                >
                  Forgot password?
                </Link>
              </div>
              {/* SignIn Button */}
              <CustomButton
                text={isLoading ? <Spinner /> : "Sign In"}
                type="submit"
                disabled={isLoading}
              />
              {/*Link for Create Account */}
              <p className="mt-4 text-center text-[16px] md:text-md text-gray-500 font-medium">
                Don’t have an account? &nbsp;
                <a href="/user-type" className="text-[#16A99A] font-bold ">
                  <span>Sign Up</span>
                </a>
              </p>
              <p className="text-center text-[16px] text-[#201D1D] font-grotesk font-medium mt-5 ">
                or
              </p>
              {/* SignIn Button with google */}
            </form>
            <button
              onClick={() => login()}
              // " "
              className=" h-[52px] w-full max-w[510px] bg-transparent text-black shadow-all text-sm font-semibold py-[15px] px-4 font-grotesk rounded-[10px] hover:bg-gray-100 transition duration-300 mt-8 flex items-center justify-center gap-[15px]"
            > 
              <img
                src={googleIcon}
                alt="Google"
                className="w-6 h-6 object-contain"
              />
              <span className="font-bold font-grotesk text-[16px] tracking-wide">
                Sign in with Google
              </span>
            </button>
          </div>
        </div>
        {/* Login Img */}
         
        <div className="w-1/2 max-h-full  overflow-hidden  hidden md:block relative">
          <img
            src={SignInImg}
            alt="Loading"
            className="w-full h-full object-cover absolute"
          />
        </div>
      </div>
    </>
  );
};
  





